












































































import { FormFieldDefMap } from '@/reusable/Form/formUtils';
import { Vue, Component, Prop } from 'vue-property-decorator';
import FormFieldsContainer from '@/reusable/Form/FormFieldsContainer.vue';
import {
  GridOptions,
  GridReadyEvent,
  GridApi,
  SelectionChangedEvent,
} from 'ag-grid-community';
import { LoadingService } from '@/services/loadingService';
import { Snotify } from '@/snotify/Snotify';
import { checkboxColumnDef } from '../../../reusable/Grid/aggridColumnDefUtils';
import MantenedorGrid from '@/reusable/Grid/MantenedorGrid.vue';
import BuscadorOperacionCrud from '@/reusable/Grid/BuscadorOperacionCrud.vue';
import InformeEventBus from '../partes/InformeEventBus';
import StepTitle from '@/reusable/Mantenedor/StepTitle.vue';
import AsociarServicioDescarga from './AsociarServicioDescarga.vue';
import AsociarProveedor from './AsociarProveedor.vue';
import AsociarClientesProveedor from './AsociarClientesProveedor.vue';
import { fetchDescargasActividad } from '@/pantallas/DescargaActividades/fetchDescargasActividad';
import { fetchProveedoresGps } from '@/reusable/proveedorGps/fetchProveedoresGps';
import { fetchClientesProveedorGps } from '@/reusable/proveedorGps/fetchClientesProveedorGps';

enum TiposAsociacionDescarga {
  serviciodescarga,
  proveedor,
  clientesproveedor,
}

@Component({
  components: {
    FormFieldsContainer,
    MantenedorGrid,
    BuscadorOperacionCrud,
    StepTitle,
    AsociarServicioDescarga,
    AsociarProveedor,
    AsociarClientesProveedor,
  },
})
export default class ContainerInformeDescargas extends Vue {
  @Prop({ default: false }) readonly: boolean;
  @Prop({ default: false }) esEditar: boolean;
  @Prop({ default: false }) esInforme: boolean;

  readonly $snotify: Snotify;
  readonly loadingService = new LoadingService();

  tiposAsociacion = TiposAsociacionDescarga;
  tipoAsociacion = TiposAsociacionDescarga.serviciodescarga;
  listadoDescargas: any = [];
  listadoProveedor: any = [];
  listadoClientesProveedor: any = [];
  listadoDescargasAll: any = [];
  listadoProveedorAll: any = [];
  listadoClientesProveedorAll: any = [];
  seleccionadosDescargas: any = [];
  seleccionadosProveedor: any = [];
  seleccionadosClientesProveedor: any = [];

  mounted() {
    this.cargarInformacionListados();
  }

  selectionChangeDescarga(listadoDes: any) {
    this.seleccionadosDescargas = listadoDes;
    this.envioDataInformesMenu();
  }

  selectionChangeProveedor(listadoProv: any) {
    this.seleccionadosProveedor = listadoProv;

    if (this.seleccionadosProveedor.length > 0) {
      let arrCliProv: any = [];
      listadoProv.forEach((pro: any) => {
        pro.clienteProveedorId.forEach((cli: any) => {
          if (!arrCliProv.includes(cli)) arrCliProv.push(cli);
        });
      });

      this.listadoClientesProveedor = this.listadoClientesProveedorAll.filter(
        (cp: any) => arrCliProv.includes(cp.id)
      );
    } else {
      this.listadoClientesProveedor = this.listadoClientesProveedorAll;
    }

    this.envioDataInformesMenu();
  }

  selectionChangeClientesProveedor(listadoCliProv: any) {
    this.seleccionadosClientesProveedor = listadoCliProv;
    this.envioDataInformesMenu();
  }

  envioDataInformesMenu() {
    let proveedoresNames: string[] = [];
    let clientesprovedoresNames: string[] = [];

    if (this.seleccionadosDescargas.length > 0) {
      this.seleccionadosProveedor = [];
      this.seleccionadosClientesProveedor = [];
      proveedoresNames.push(this.seleccionadosDescargas[0].proveedor.nombre);
      clientesprovedoresNames.push(
        this.seleccionadosDescargas[0].clienteProveedor.nombre
      );
    } else {
      proveedoresNames = this.seleccionadosProveedor.map((x: any) => x.nombre);
      clientesprovedoresNames = this.seleccionadosClientesProveedor.map(
        (x: any) => x.nombre
      );

      if (
        this.seleccionadosProveedor.length > 0 &&
        this.seleccionadosClientesProveedor.length === 0
      ) {
        let arrCliProv: any = [];
        let arrCliProvSelec: any = [];
        this.seleccionadosProveedor.forEach((pro: any) => {
          pro.clienteProveedorId.forEach((cli: any) => {
            if (!arrCliProv.includes(cli)) arrCliProv.push(cli);
          });
        });

        arrCliProvSelec = this.listadoClientesProveedorAll.filter((cp: any) =>
          arrCliProv.includes(cp.id)
        );

        clientesprovedoresNames = arrCliProvSelec.map((x: any) => x.nombre);
      }

      if (
        this.seleccionadosClientesProveedor.length > 0 &&
        this.seleccionadosProveedor.length === 0
      ) {
        let arrProv: any = [];
        let arrProvSelec: any = [];
        this.seleccionadosClientesProveedor.forEach((cli: any) => {
          cli.proveedoresId.forEach((pro: any) => {
            if (!arrProv.includes(pro)) arrProv.push(pro);
          });
        });

        arrProvSelec = this.listadoProveedorAll.filter((p: any) =>
          arrProv.includes(p.id)
        );

        proveedoresNames = arrProvSelec.map((x: any) => x.nombre);
      }
    }

    let info = {
      infoProvedor: proveedoresNames,
      infoClienteProveedor: clientesprovedoresNames,
    };

    InformeEventBus.$emit('seleccionDataInformeDescargas', info);
  }

  async cargarInformacionListados() {
    this.listadoDescargasAll = (await this.fetchDescargas()) || [];
    this.listadoDescargas = this.listadoDescargasAll.map((data: any) => ({
      ...data,
      nombre: data.proveedor.nombre + '_' + data.clienteProveedor.nombre,
    }));
    this.listadoProveedorAll = (await this.fetchProveedor()) || [];
    this.listadoClientesProveedorAll =
      (await this.fetchClienteProveedor()) || [];
    this.listadoProveedor = this.listadoProveedorAll;
    this.listadoClientesProveedor = this.listadoClientesProveedorAll;
  }

  fetchDescargas() {
    this.loadingService.showLoading();
    return fetchDescargasActividad()
      .catch(() =>
        this.$snotify.error(
          this.$t('mensajes.mensajesError.consulta', {
            entidad: 'las Descargas de Información',
          })
        )
      )
      .finally(() => this.loadingService.hideLoading());
  }

  fetchProveedor() {
    this.loadingService.showLoading();
    return fetchProveedoresGps()
      .catch(error => {
        if (error.response.status != 404) {
          this.$snotify.error(
            'Ha ocurrido un error al intentar obtener los Proveedores',
            { timeout: 3000 }
          );
        }
      })
      .finally(() => this.loadingService.hideLoading());
  }

  fetchClienteProveedor() {
    this.loadingService.showLoading();
    return fetchClientesProveedorGps()
      .catch(error => {
        if (error.response.status != 404) {
          this.$snotify.error(
            'Ha ocurrido un error al intentar obtener los Clientes',
            { timeout: 3000 }
          );
        }
      })
      .finally(() => this.loadingService.hideLoading());
  }
}
